<template>
<form v-on:submit.prevent="setFBAnswer" autocomplete="off" role="presentation">
  <div class="card">
    <div class="card-middle">
      <div class="card-middle-inside">
        <h2>Fortæl først lidt om jeres virksomhed</h2>
        <p>Vi deler gerne ud af vores faglige viden og ekspertise. Til gengæld vil vi gerne kontakte dig med information og hjælp til at komme i gang.</p>
        <div class="permission-2col">
          <div class="permission-col">
            <fieldset class="form-group">
              <label for="username">Dit fulde navn</label>
              <input v-model="firm.user.name" type="text" class="form-control" id="username" placeholder="Fornavn Efternavn" required>
            </fieldset>
          </div>
          <div class="permission-col">
            <fieldset class="form-group">
              <label for="zip">Dit firmas postnummer</label>
              <input v-model="firm.zipCode" type="text" class="form-control" id="zip" required @keydown="isNumber()" placeholder="Postnummer" @keyup="checkLengthZip(firm.zipCode, 4)">
            </fieldset>
          </div>
        </div>
        <fieldset class="form-group">
          <label for="firm-name">Firmanavn</label>
          <input autocomplete="new-password" @input="checkTdcID(firm.zipCode, firm.firmName)" v-model="firm.firmName" @keydown.down='down' @keydown.up='up' @keydown.prevent.default.enter='setVal(current)' type="text" class="form-control" id="firm-name" placeholder="Udfyld venligst postnummer først"
            required :readonly="firmActive">
          <div class="dropdown-wrap">
            <ul v-if="autocomplete" class="dropdown">
              <li v-for="(c, cCount) in auto" v-bind:class="{'active': isActive(cCount)}" class="dropdown-item">
                <a href="#" @click.prevent.default="setVal(cCount)" class="dropdown-link">{{c.AccountName}}</a>
              </li>
            </ul>
          </div>

        </fieldset>
        <div class="permission-2col">
          <div class="permission-col">

            <fieldset class="form-group">
              <label for="phone">Dit telefonnummer</label>
              <input v-model="firm.phone" type="text" class="form-control" id="phone" placeholder="F.eks 12 34 56 78" required @keydown="isNumber()" @keyup="checkLengthPhone(firm.phone, 8)">
            </fieldset>

          </div>
          <div class="permission-col">
            <fieldset class="form-group">
              <label for="email">Din e-mail</label>
              <input @blur="verifyEmail" v-model="firm.email" type="email" class="form-control" id="email" placeholder="F.eks din@email.dk" required>
              <span v-if="mailCheckedEmail" class='form--notice form--suggestEmail' @click="setNewMail">
                    Mente du <span>{{ mailCheckedEmail }}</span>?
              </span>
              <span v-if="mailfalse" class='form--notice form--suggestEmail' @click="setNewMail">
                    Indtast korrekt email
                  </span>
            </fieldset>
          </div>
        </div>
        <div class="mt-5">
          <div>
            <fieldset class="permission-check">
              <input v-model="firm.user.permissionemail" type="checkbox" class="permission-check-input" id="permission" required>
              <appPermissionText :linkRed="true" />
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="card-bottom">
      <div class="card-bottom-inside">
        <div class="card-2col">
          <div class="card-col">
            <button type="submit" class="btn btn-light">Start sikkerhedstjekket</button>
          </div>
          <div class="card-col" v-html="data">

          </div>
        </div>
      </div>
    </div>
  </div>
</form>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import { db } from '@/database/firebase';
import Axios from 'axios';
import Mailcheck from 'mailcheck';
import PermissionText from '@/components/modular/PermissionText.vue';

export default {
  name: 'permissionemail',
  components: {
    appPermissionText: PermissionText
  },
  props: {
    data: {
      type: String
    }
  },
  data() {
    return {
      auto: '',
      current: 0,
      mailCheckedEmail: undefined,
      autocomplete: false,
      firmActive: true,
      mailfalse: false
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'globalC',
      'answers',
      'answersCount',
      'surveyIsActive',
      'firm',
      'whatPop',
      'avarage'
    ])
  },
  methods: {
    ...mapActions([
      'setPrev',
    ]),
    setNewMail() {
      this.firm.email = this.mailCheckedEmail;
      this.mailCheckedEmail = undefined;
      this.mailfalse = false
    },
    verifyEmail: function() {
      let self = this;

      Mailcheck.run({
        email: self.firm.email,
        suggested: function(suggestion) {
          self.mailCheckedEmail = suggestion.full;
        },
        empty: function() {

        }
      })

    },
    checkLengthZip(len, max) {
      if (len) {
        if (len.length > max) {
          this.firm.zipCode = len.substring(0, len.length - 1);
        }
        if (len.length == max) {
          this.firmActive = false;
        }
      }
    },
    checkLengthPhone(len, max) {
      if (len) {
        if (len.length > max) {
          this.firm.phone = len.substring(0, len.length - 1);
        }
      }

    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 || charCode == 190) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkTdcID(zip, val) {
      let self = this;
      if (val.length > 1) {
        this.autocomplete = true;
        this.current = 0;
        Axios.get('https://mdb.falck.com/api/ErhvervData/Get?name=' + zip + '%20' + val)
          .then(function(response) {
            self.auto = response.data;
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.autocomplete = false;
      }

    },
    setVal(count) {
      this.firm.firmName = this.auto[count].AccountName;
      this.firm.TDCId = this.auto[count].TDCId;
      this.firm.cvr = this.auto[count].CVR;
      this.firm.street = this.auto[count].Streetname;
      this.firm.streetnumber = this.auto[count].Streetnumber;
      this.firm.floor = this.auto[count].Floor;
      this.firm.zipCode = this.auto[count].Zip;
      this.firm.city = this.auto[count].Town;
      this.firm.AccountId = this.auto[count].AccountId;
      this.autocomplete = false;
    },
    up() {
      if (this.current > 0) {
        this.current--
      }
    },
    // When up pressed while suggestions are open
    down() {
      if (this.current < this.auto.length - 1) {
        this.current++
      }
    },
    enter() {
      this.firm.name = this.auto[this.current].AccountName;
      this.autocomplete = false;
    },
    isActive(index) {
      return index === this.current
    },
    setFBAnswer() {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(this.firm.email)) {
        this.mailfalse = true
        return true
      }
      if (this.firm.user.permissionemail && this.firm.TDCId) {
        this.firm.firmId = Date.now();
        var s = this.$route.params.survey
        this.$router.push({ path: '/survey/v2/'+s+'/before' })
      } else {
        alert("Du skal vælge firma fra dropdown")
      }

    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.card-middle-inside{
  padding: 49px 120px 30px 120px;
  width: auto;
  max-width: 1024px;
  @media(max-width: 1023px){
    padding:50px 16px 0;
  }
}


.form--notice {
  margin-top: 10px;
  display: block;
}

.form--notice span {
  text-decoration: underline;
  cursor: pointer;
}
.card-bottom-inside{
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/extended/permissionEmail.vue